import { render, staticRenderFns } from "./ConversationMessageDrawer.vue?vue&type=template&id=470b9b2e&scoped=true"
import script from "./ConversationMessageDrawer.vue?vue&type=script&lang=js"
export * from "./ConversationMessageDrawer.vue?vue&type=script&lang=js"
import style0 from "./ConversationMessageDrawer.vue?vue&type=style&index=0&id=470b9b2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470b9b2e",
  null
  
)

export default component.exports